import React, {Fragment} from 'react';

const defaultStyle = {
  height: '100%',
  display: "flex"
};

function MainMenu({children, className}) {
  return (
    <Fragment>
      <nav className={className} style={defaultStyle}>
        {children}
      </nav>
    </Fragment>
  );
}

export default MainMenu;
